// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"458":"b12837d5","565":"7b83cc74"}[chunkId] + ".chunk.css";
};